import { render, staticRenderFns } from "./FlipBookAddToCartBtnBook.vue?vue&type=template&id=35aa4087&scoped=true"
import script from "./FlipBookAddToCartBtnBook.vue?vue&type=script&lang=js"
export * from "./FlipBookAddToCartBtnBook.vue?vue&type=script&lang=js"
import style0 from "./FlipBookAddToCartBtnBook.vue?vue&type=style&index=0&id=35aa4087&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aa4087",
  null
  
)

export default component.exports